import React, { useState } from "react";
import PageContainer from "../PageContainer";
import SidebarMenu from "../SidebarMenu";
import {
  ProviderInfo,
  ProviderRow,
  InfoBlock,
  Info,
  InfoTitle,
  Page,
  ImageContainer,
  InputPrestador,
  ButtonPrestador,
} from "./styles";
import { PageTitle } from "../../Pages/SignedIn/Creditos/styles";
import api from "../../Services/api";
import { toast, ToastContainer } from "react-toastify";
import { FaDownload } from "react-icons/fa";

const InfosMedico = ({ prestador, buttons, pendente = false }) => {
  const [novoValorRepasse, setNovoValorRepasse] = useState("");
  const [valorMargemMedico, setValorMargemMedico] = useState(prestador?.VL_margem_individual ? (parseFloat(prestador?.VL_margem_individual) * 100) : "0");

  const handleAtualizarRepasse = async () => {
    try {
      const novoValorRepasseFloat = parseFloat(novoValorRepasse / 100);

      await api.patch(`/admin/atualizar_margem_indivudal/${prestador.id_usuario}`, { VL_margem_individual: novoValorRepasseFloat });
      toast.success("Valor de repasse atualizado com sucesso!", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setValorMargemMedico(novoValorRepasse);

    } catch (error) {
      console.error("Erro ao atualizar o valor de repasse:", error);
      toast.error("Erro ao atualizar o valor de repasse", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleDownloadPdf = async () => {
    try {
      const response = await fetch(prestador?.DS_documento_url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Nome amigável: Documento_NomePrestador.pdf
      const nomePrestador = prestador?.usuario?.NO_primeiro_nome || 'Prestador';
      const sobrenome = prestador?.usuario?.NO_ultimo_nome || '';
      const nomeCompleto = sobrenome ? `${nomePrestador}_${sobrenome}` : nomePrestador;
      link.download = `Documento_${nomeCompleto}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar o documento:", error);
      toast.error("Erro ao baixar o documento", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };


  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        <ToastContainer />
        <PageTitle>Prestador</PageTitle>
        <ProviderInfo>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>Nome:</InfoTitle>
              <Info>
                {prestador?.usuario.NO_ultimo_nome
                  ? prestador?.usuario.NO_primeiro_nome +
                  " " +
                  prestador?.usuario.NO_ultimo_nome
                  : prestador?.usuario.NO_primeiro_nome}
              </Info>
            </InfoBlock>
            {!prestador?.usuario.NO_ultimo_nome && (
              <InfoBlock>
                <InfoTitle>Razão Social:</InfoTitle>
                <Info>{prestador?.usuario.DS_razao_social}</Info>
              </InfoBlock>
            )}
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>{prestador?.usuario.NU_cpf ? "CPF:" : "CNPJ:"}</InfoTitle>
              <Info>{prestador?.usuario.NU_cpf || prestador?.usuario.NU_cnpj}</Info>
            </InfoBlock>
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>Email:</InfoTitle>
              <Info><a href={`mailto:${prestador?.usuario.DS_email}`}>{prestador?.usuario.DS_email}</a></Info>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Telefone:</InfoTitle>
              <Info>{prestador?.usuario.NU_telefone}</Info>
            </InfoBlock>
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>CRM:</InfoTitle>
              <Info>{prestador?.CD_numero_registro_profissional}</Info>
            </InfoBlock>
            {/* <InfoBlock>
              <InfoTitle>Créditos:</InfoTitle>
              <Info>{prestador?.VL_consulta_em_credito} crédito(s)</Info>
            </InfoBlock> */}
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>Valor da Consulta:</InfoTitle>
              <Info>{prestador?.VL_consulta_em_credito}</Info>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Chave Pix:</InfoTitle>
              <Info>{prestador?.usuario.dados_pix.TP_chave_pix + ": " + prestador?.usuario.dados_pix.CD_chave_pix}</Info>
            </InfoBlock>
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>Especialidades:</InfoTitle>
              <Info>
                {prestador?.especialidades.map(
                  (item) => item.NO_especialidade + ", "
                )}
              </Info>
            </InfoBlock>
            {!pendente &&
              <InfoBlock>
                <InfoTitle>
                  Repasse Individual:{" "}
                  {valorMargemMedico}
                  %
                </InfoTitle>
                <InputPrestador
                  type="number"
                  placeholder="Insira o valor"
                  value={novoValorRepasse}
                  onChange={(e) => {
                    const newValue = Math.min(100, Math.max(0, e.target.value));
                    setNovoValorRepasse(newValue);
                  }}
                  min="0"
                  max="100"
                />
                <ButtonPrestador onClick={handleAtualizarRepasse}>
                  Atualizar Repasse
                </ButtonPrestador>
              </InfoBlock>}
          </ProviderRow>
          <ProviderRow>
            <InfoBlock>
              <InfoTitle>Identidade:</InfoTitle>
              {prestador?.TP_documento === 'pdf' ? (
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <button
                    onClick={handleDownloadPdf}
                    style={pdfButtonStyle}
                  >
                    <FaDownload />
                    Baixar PDF
                  </button>
                </div>
              ) : (
                <ImageContainer src={prestador?.DS_documento_url} alt=""></ImageContainer>
              )}
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Foto de Perfil:</InfoTitle>
              <ImageContainer
                src={prestador?.usuario.DS_image_url}
                alt=""
              ></ImageContainer>
            </InfoBlock>
          </ProviderRow>
          <ProviderRow>{buttons}</ProviderRow>
        </ProviderInfo>
      </PageContainer>
    </Page>
  );
};

const pdfButtonStyle = {
  padding: '10px 16px',
  backgroundColor: '#067187',
  color: 'white',
  borderRadius: '8px',
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '14px',
  fontWeight: '500',
  transition: 'background-color 0.2s ease',
  cursor: 'pointer',
  border: 'none',
};

export default InfosMedico;

